import type { PointerEvent as ReactPointerEvent } from "react";

const mobileDialogQuery = "(max-width: 720px), (pointer: coarse)";

export function focusDialogFieldOnDesktop(event: Event) {
  event.preventDefault();
  if (typeof window === "undefined" || window.matchMedia?.(mobileDialogQuery).matches) return;

  const content = event.currentTarget as HTMLElement | null;
  window.requestAnimationFrame(() => {
    content?.querySelector<HTMLElement>("[data-dialog-autofocus]")?.focus({ preventScroll: true });
  });
}

export function mobileSheetDismissProps(onDismiss: () => void) {
  let startY: number | undefined;
  let pointerId: number | undefined;

  return {
    onPointerDown(event: ReactPointerEvent<HTMLElement>) {
      if (!window.matchMedia?.(mobileDialogQuery).matches) return;
      const bounds = event.currentTarget.getBoundingClientRect();
      if (event.clientY > bounds.top + 88) return;
      startY = event.clientY;
      pointerId = event.pointerId;
      event.currentTarget.setPointerCapture?.(event.pointerId);
    },
    onPointerUp(event: ReactPointerEvent<HTMLElement>) {
      if (pointerId !== event.pointerId || startY === undefined) return;
      const shouldDismiss = event.clientY - startY >= 72;
      startY = undefined;
      pointerId = undefined;
      if (shouldDismiss) onDismiss();
    },
    onPointerCancel() {
      startY = undefined;
      pointerId = undefined;
    },
  };
}
